'use strict';

import Zone from './zone/Zone.service'

const state = {}

const actions = {
  ...Zone.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }